import { Reducer } from 'redux';

import { AccommodationArrangedStatusEnum, AccommodationTypeStatusEnum, TravelStatusEnum } from 'types';

import { StudentActionTypes } from '../types';
import { IEnrolmentStatusState } from './types';

const initialState: IEnrolmentStatusState = {
  travelStatusSection: {
    status: TravelStatusEnum.None,
    bookedDate: '',
    bookedArrivingDate: '',
    arrivalDate: '',
    haveTravelTicket: '',
    travelCanceledReason: '',
    travelPreventedReason: '',
    deferReason: '',
    withdrawReason: ''
  },
  accommodationStatusSection: {
    arrangedStatus: AccommodationArrangedStatusEnum.NONE,
    typeStatus: AccommodationTypeStatusEnum.NONE
  }
};

const reducer: Reducer<IEnrolmentStatusState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return {
        ...state,
        ...action.payload.student.enrolmentStatus
      };
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
      return {
        ...state,
        ...action.payload.enrolmentStatus
      };
    default: {
      return state;
    }
  }
};

export { reducer as enrolmentStatusReducer };
